<template>
  <div
    ref="reference"
    class="tw-h-12 tw-mx-4 tw-py-2 tw-w-full tw-inline-flex tw-items-center tw-justify-between tw-no-underline tw-cursor-pointer"
  >
    <div>
      <div
        data-cy="status-switcher"
        class="tw-font-normal tw-text-base tw-select-none tw-text-gray-800"
      >
        {{ selectedStatus.label }}
      </div>
      <div v-show="false" ref="tooltip">
        <div
          class="tw-w-56 tw-rounded tw-overflow-auto"
          style="width: 248px; max-height: 420px;"
          data-cy="status-switcher-list"
        >
          <div class="tw-px-4 tw-py-4 tw-text-gray-600 tw-leading-none">
            Show
          </div>
          <a
            v-for="status in statusList"
            :key="status.label"
            class="tw-flex tw-justify-start tw-items-center tw-p-4 tw-cursor-pointer tw-no-underline tw-overflow-hidden hover:tw-bg-gray-300"
            @click.prevent="selectStatus(status)"
          >
            <span class="tw-font-normal" v-text="status.label" />
          </a>
        </div>
      </div>
    </div>
    <svg-icon
      name="cheveron-down"
      class="tw-ml-1 tw-w-5 tw-h-5 tw-cursor-pointer tw-text-gray-800"
    />
  </div>
</template>

<script>
import tippy from 'tippy.js'

export default {
  name: 'StatusSwitcher',

  data: () => ({
    statusList: [
      { label: 'All Status', value: 'ALL' },
      { label: 'Joined', value: 'JOINED' },
      { label: 'Invited', value: 'INVITED' },
      { label: 'Not invited', value: 'NOT_INVITED' },
      { label: 'Archived', value: 'ARCHIVED' },
      { label: 'Deleted', value: 'DELETED' },
    ],
  }),

  computed: {
    selectedStatus: {
      get() {
        if (!this.$route.query.status) {
          return this.statusList.find(status => status.value === 'ALL')
        }

        return this.statusList.find(
          status => status.value === this.$route.query.status
        )
      },
    },
  },

  mounted() {
    this.tippy = tippy.one(this.$refs.reference, {
      html: this.$refs.tooltip.firstChild,
      trigger: 'click',
      position: 'bottom',
      interactive: true,
      theme: 'light',
      animation: 'scale',
      inertia: true,
      arrow: true,
    })

    this.$once('hook:beforeDestroy', () => {
      this.tippy.destroy()
    })
  },

  methods: {
    selectStatus(selectedStatus) {
      this.tippy.hide()
      if (selectedStatus.value === 'ALL') {
        let query = { ...this.$route.query }
        delete query.status
        this.$router.replace({ query }, () => {})
      } else {
        this.$router.push(
          {
            query: {
              ...this.$route.query,
              status: selectedStatus.value,
            },
          },
          () => {}
        )
      }
    },
  },
}
</script>
